import { render, staticRenderFns } from "./FaculteEdit.vue?vue&type=template&id=2e01e6fa&"
import script from "./FaculteEdit.vue?vue&type=script&lang=js&"
export * from "./FaculteEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports